<mat-dialog-content>
    <div>
        <mat-form-field class="question">
            <input required
                   matInput
                   [(ngModel)]="newQuestion.question" id="NewQuestion">
            <mat-placeholder>Question</mat-placeholder>
            <mat-error>Please provide the question to be answered</mat-error>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field class="answer" floatLabel='never'>
        <textarea required
                  cdkAutosizeMinRows="5"
                  cdkTextareaAutosize
                  matInput
                  [(ngModel)]="newQuestion.answer" id="NewQuestionAns">
        </textarea>
            <mat-placeholder>Answer</mat-placeholder>
            <mat-error>Please provide the answer to the question</mat-error>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions">
    <button (click)="save()" [mat-dialog-close]="true" color="primary" mat-raised-button id="NewQuestionSave">Save</button>
    <button [mat-dialog-close]="false" color="primary" mat-raised-button id="NewQuestioncancel">Cancel</button>
</mat-dialog-actions>
